export interface PublicParams {
  bigRegion?: string;
  region?: string;
  city?: string;
  businessDistrictId?: string;
  businessType?: number;
  startDate?: string;
  endDate?: string;
}
export interface RealtimeOrderOrGmv {
  date: string;
  data: RealtimeOrderOrGmvItem[];
}
export interface InitialState {
  selectedBigRegion: string;
  selectedRegion: string;
  selectedCity: string;
  selectedBusinessDistrictId: string;
  selectedBusinessType: number | string; // 0-饭圈 1-包餐企业 2-非包餐企业
  selectedDim: number; // 1-订单数 2-GMV
  overview: Overview;
  realtimeOrderOrGmvToday: RealtimeOrderOrGmv | null;
  realtimeOrderOrGmvYesterday: RealtimeOrderOrGmv | null;
  realtimeOrderOrGmvSomeday: RealtimeOrderOrGmv | null;
  someday: string | null;
  businessTypeDistribution: BusinessTypeDistribution | null;
  orderStatusDistribution: OrderStatusDistribution | null;
  groupMasterRankList: GroupMasterRankItem[] | null;
  groupMasterRankListMore: GroupMasterRankItem[] | null;
  groupMasterRankListMoreModalVisible: boolean;
  rightRankData: RightRank | null;
  rightRankMoreData: rightRankItem[] | null;
  rightRankMoreType: RightRankType;
  rightRankMoreModalVisible: boolean;
  selectedAreaText: string;
  selectedTreeData: any;
  selectedAllTreeData: any;
  districtDefaultValue: any;
}

export interface GetAreaTreeParams {
  level: number; // 0-大区 1-片区 2-城市
  title?: string;
}

export interface CommonItem {
  name: string;
  id: string;
}

export interface GetDistrictListParams {
  name?: string;
}

export interface OrderTrendParams {
  bigRegion?: string;
  region?: string;
  city?: string;
  businessDistrictId?: string;
  businessType?: number;
  startDate?: string;
  endDate?: string;
  dateType?: number;
  dim?: number;
  isCompare?: boolean;
  replenishType?: number | string;
}

export interface OrderTrendData {
  name: string;
  date: string;
  value: string;
}

export interface OrderInfoParams {
  bigRegion?: string;
  region?: string;
  city?: string;
  businessDistrictId?: string;
  businessType?: number;
  startDate?: string;
  endDate?: string;
  pageSize?: number;
  replenishType?: number | string;
}

export interface OrderBusinessParams extends PublicParams {}
// export interface RetentionInfoParams {
//   cumulativeRegUserNum?: string;
//   cumulativeOrderNum?: string;
//   lastMonthRetainedUserNum?: string;
//   lastMonthRetainedUserRate?: string;
// }

export interface RetentionInfoParams {
  bigRegion?: string;
  region?: string;
  city?: string;
  businessDistrictId?: string;
  companyType?: number;
  customerGroupType?: number;
  startDate?: string;
  endDate?: string;
  pageSize?: number;
  index?: number;
}

export interface RetentionTableParams {
  bigRegion?: string;
  region?: string;
  city?: string;
  businessDistrictId?: string;
  companyType?: number;
  customerGroupType?: number;
  startDate?: string;
  endDate?: string;
  pageSize?: number;
  page?: number;
  isDownload?: number;
}

export interface queryFormDataType {
  bigRegion?: string;
  region?: string;
  city?: string;
  businessDistrictId?: string;
  businessType?: number;
}

export enum BusinessType {
  group,
  packed,
  unpacked,
  other,
}

export enum CompanyType {
  other,
  packed,
  unpacked,
  samepacked,
}

export enum CustomerGroupType {
  other,
  group,
}

export interface CommonParams {
  bigRegion?: string;
  region?: string;
  city?: string;
  businessDistrictId?: string;
  businessType?: number;
  startDate?: string;
  endDate?: string;
  pageSize?: number;
}

export interface Overview {
  gmv: {
    gmv: number;
    validGmv: number;
    realPayGmv?: number;
  };
  order: {
    submitOrderNum: number;
    validOrderNum: number;
    pricePerSku: string;
  };
  platForm: {
    platformValidSubsidyRate: string;
    platformValidSubsidy: string;
    shopValidDiscountsAmount: string;
  };
  uv: {
    uv?: string;
    miniAppUserRegNumber: string;
    orderUserNumber: string;
  };
  onTime: {
    fsDeliveryOntimeRate: string;
    fsDeliveryOrderNum: string;
    fsDeliveryTimeoutOrderNum?: string;
  };
  evaluate: {
    poorEvaluateRate: string;
    skuPoorEvaluateRate: string;
    logisticsPoorEvaluateRate: string;
  };
}

export interface UseInfoData {
  miniAppUserRegNumber: number;
  newUserVisNumber: number;
  newRegUserNumber: number;
  reorderUserRate: string;
  newusernum: number;
  orderedusernum: number;
  reorderusernumber: number;
}

export interface GetRealtimeOrderOrGmvParams extends CommonParams {
  date: string;
}

export interface RealtimeOrderOrGmvItem {
  time: string; // 时段
  value: number; // 时段订单数orGMV
  cumVal: number; // 日累计值
}

export interface BusinessOrderDistribution {
  orderTypeName: string;
  orderNum: number;
}

export interface OrderTypeDistribution {
  orderTypeName: string;
  orderNum: number;
}
export interface BusinessTypeDistribution {
  packageMeal: number; // 包餐
  unPackageMeal: number; // 非包餐
  customerGroup: number; // 饭圈
  otherBusinessType: number; // 其他
}

export interface OrderOrderTypesDistribution {
  takeOut: number;
  selfLift: number;
  dine: number;
  payAtStore: number;
  coupons: number;
  welfareMall: number;
}

export interface OrderStatusDistribution {
  appointment: number; // 预约中
  waitForAccept: number; // 待接单
  accepted: number; // 已接单
  inDelivery: number; // 配送中
  finished: number; // 已完成
}

export interface GroupMasterRankItem {
  name: string; // 姓名
  city: string; // 城市
  cbdName: string; // 商圈名
  value: number; // 订单量orGMV
}

export interface rightRankItem {
  name: string; // 名称
  packed: number; // 包餐
  unpacked: number; // 非包餐
  group: number; // 饭圈
  other: number; // 其他
}

export interface RightRank {
  bigRegionList: rightRankItem[];
  cityList: rightRankItem[];
  businessDistrictList: rightRankItem[];
  companyList: rightRankItem[];
  shopList: rightRankItem[];
}

export interface EnterpriseUserRankings {
  companyName: string;
  importUserNum: number;
  rankColumnNum: number;
}

export interface GroupmasteUserRankings {
  gridName: string;
  rankColumnNum: number;
}

export interface FunnelTypes {
  miniAppUserRegNumber: number;
  merchantListPageUserNumber: number;
  orderSubmitPageVisNumber: number;
  submitBtClickUserNumber: number;
}

export interface FetchOverviewParams {
  shopId?: string;
  subShopId?: string;
  bigRegion?: string;
  region?: string;
  city?: string;
  skuBaseChannel?: string;
  startDate?: string;
  endDate?: string;
  pageSize?: number;
  pageNum?: number;
}

export interface MerchandiseListParams {
  shopId?: string;
  subShopId?: string;
  bigRegion?: string;
  region?: string;
  city?: string;
  skuBaseChannel?: string;
  startDate?: string;
  endDate?: string;
  isForm?: number;
  companyId?: string;
  businessType?: string;
  orderTimeQuantum?: string;
  orderType?: string;
  pageNum?: number;
  pageSize?: number;
}

export enum RightRankType {
  bigRegionList = 'bigRegionList',
  cityList = 'cityList',
  businessDistrictList = 'businessDistrictList',
  companyList = 'companyList',
  shopList = 'shopList',
}
export interface RegionItem {
  id: string;
  name: string;
}

// export enum MoreRankType {
//   bigRegionList = 'bigregion',
//   cityList = 'city',
//   businessDistrictList = 'businessgroup',
//   companyList = 'enterprise',
//   shopList = 'store',
// }

export enum UserDataRankType {
  firm = 'firm',
  fandom = 'fandom',
}

export type OverallOverviewProps = {
  title: string;
  setDefaultDateSelection: (date: any) => void;
  dataTabsKey: string;
};
// 补单
export enum SupplyType {
  unsupply,
  supply,
}
